import useStyles from "../styles"
import { strings as Localization } from "../../../lib/Localization"
// eslint-disable-next-line import/no-cycle
import { DeviceSearchbar, LeftRightSteeringFilter, VehicleSearchbar } from "../../AutocompleteSearch"
// eslint-disable-next-line import/no-cycle
import AsyncSearch from "../../AsyncSearch/AsyncSearch"
import { useLanguage } from "../../../lib/hooks/languageHooks"
import { Box, Button } from "@material-ui/core"
import React from "react"
import MenuOpenIcon from "@material-ui/icons/MenuOpen"
import MenuIcon from "@material-ui/icons/Menu"

function MobileSearchArea({ handleOpenDrawer, drawerIsOpen, showingSearch }) {
    const classes = useStyles()
    const language = useLanguage()

    return (
        <Box style={{ display: (showingSearch) ? "flex" : "none", justifyContent: "space-between", flexDirection: "column" }}>
            <Box style={{ display: "flex" }}>
                <Box className={classes.searchArea}>
                    <DeviceSearchbar sx={{ width: { xs: "100%", sm: "250px" }, marginRight: { xs: "32px", sm: "0px", md: "32px" } }} />
                    <VehicleSearchbar sx={{ width: { xs: "100%", sm: "250px" }, marginRight: { xs: "32px", sm: "0px", md: "32px" } }} />
                    <Box sx={{ display: "flex", width: { xs: "100%", sm: "auto" }, marginRight: { xs: "32px", sm: "0px", md: "32px" } }}>
                        <AsyncSearch sx={{ width: { xs: "auto", sm: "250px" } }} />
                    </Box>
                </Box>
                <Box>
                    <Box className={classes.mobileMenuButton}>
                        <Button
                            style={{
                                minWidth: 140
                            }}
                            variant="text"
                            size="large"
                            onClick={handleOpenDrawer}
                            startIcon={drawerIsOpen ? <MenuOpenIcon /> : <MenuIcon />}
                        >
                            {Localization.products}
                        </Button>
                    </Box>
                    <Box
                        style={{
                            display: "flex", alignItems: "center", justifyContent: "flex-start", paddingLeft: 8
                        }}
                        sx={{ marigRight: { md: "-24px" } }}
                    >
                        {
                            (language === "en")
                            && <LeftRightSteeringFilter />
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default MobileSearchArea
